import React from 'react';

export function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-logo">
        <h1>Trade<span>Life</span></h1>
        <p className="loading-tagline">Built for Trades</p>
      </div>
      <div className="loading-spinner" />
    </div>
  );
}

export default LoadingScreen;
